import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { ICellRendererAngularComp } from 'ag-grid-angular';

interface ToogleOptionsLabels {
  checked: string;
  unchecked: string;
}

interface GridToggleComponentParams extends ICellRendererParams {
  toggleOptionsLabels: ToogleOptionsLabels;
}

@Component({
    selector: 'app-grid-toggle',
    templateUrl: './grid-toggle.component.html',
    styleUrls: ['./grid-toggle.component.scss'],
    standalone: false
})
export class GridToggleComponent implements ICellRendererAngularComp {
  params: ICellRendererParams = {} as ICellRendererParams;
  toggleOptions = ['none', 'checked', 'unchecked']; // Naming this as generic options so component can be re-usable.
  toggleOptionsLabels: ToogleOptionsLabels = {
    // Set these values as default;
    checked: 'Yes',
    unchecked: 'No',
  };
  selectedOption = 0;
  constructor() {}

  agInit(params: GridToggleComponentParams) {
    this.params = params || ({} as GridToggleComponentParams);
    this.toggleOptionsLabels = params.toggleOptionsLabels;
    this.selectedOption = this.toggleOptions.indexOf(this.params.value);
  }

  refresh(params: ICellRendererParams) {
    params?.refreshCell?.();
    return false;
  }

  toggleHandler(option: number) {
    const colId = this?.params?.column?.getColId();
    const node = this.params.node;
    this.selectedOption = option === this.selectedOption ? 0 : option;
    if (node && colId) {
      // Row node
      node.setDataValue(colId, this.toggleOptions[this.selectedOption]);
    }
  }
}
